import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

// Ultra-optimized Framer Motion version
export default function CheckValue({ number, extra }) {
  const prevValue = useRef(number);
  const [currentColor, setCurrentColor] = useState("default");

  useEffect(() => {
    if (number === prevValue.current) return;

    if (number > prevValue.current) {
      setCurrentColor("buy");
    } else if (number < prevValue.current) {
      setCurrentColor("sell");
    }

    prevValue.current = number;

    const timer = setTimeout(() => setCurrentColor("default"), 300);
    return () => clearTimeout(timer);
  }, [number]);

  const colorMap = {
    buy: { backgroundColor: "var(--buy)", color: "var(--white)" },
    sell: { backgroundColor: "var(--sell)", color: "var(--white)" },
    default: { backgroundColor: "var(--background)", color: "var(--text)" }
  };

  return (
    <motion.h1
      className={`${extra} mr-1 text-[12px] relative flex items-center justify-center gap-1 font-medium uppercase rounded-md cursor-pointer border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.1)]`}
      style={{ width: "90%" }}
      animate={colorMap[currentColor]}
      transition={{ duration: 0.1 }}
    >
      {number}
    </motion.h1>
  );
}
